import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import React, { useLayoutEffect, useRef } from 'react';
import showMessage from '../../../helpers/showMessage';
import { ERROR_MESSAGES } from '../../../configs/messages';
import { useSnackbar } from 'notistack';

am4core.useTheme(am4themes_animated);

function EpgGraph({ graphData }) {
    const chart = useRef(null);

    const { enqueueSnackbar } = useSnackbar();

    useLayoutEffect(() => {
        let x = am4core.create('chartdiv', am4charts.XYChart);
        x.colors.step = 2;

        x.legend = new am4charts.Legend();
        x.legend.position = 'bottom';
        x.legend.paddingBottom = 40;
        x.legend.labels.template.maxWidth = 95;

        var xAxis = x.xAxes.push(new am4charts.CategoryAxis());
        xAxis.dataFields.category = 'category';
        xAxis.renderer.cellStartLocation = 0.1;
        xAxis.renderer.cellEndLocation = 0.9;
        xAxis.renderer.grid.template.location = 0;

        var yAxis = x.yAxes.push(new am4charts.ValueAxis());
        yAxis.min = 0;
        yAxis.title.text = "Үргэлжлэх хугацаа (хувиар)";

        function createSeries(value, name) {
            var series = x.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = value;
            series.dataFields.categoryX = 'category';
            // series.tooltipText = "{categoryX}: {valueY}";
            series.name = name;

            series.events.on('hidden', arrangeColumns);
            series.events.on('shown', arrangeColumns);

            var bullet = series.bullets.push(new am4charts.LabelBullet());
            bullet.interactionsEnabled = false;
            bullet.dy = 30;
            bullet.label.text = '{valueY}';
            bullet.label.fill = am4core.color('#ffffff');

            return series;
        }
        x.data = graphData;

        if (!graphData.length) {
            showMessage(ERROR_MESSAGES.GRAPH_DATA_IS_EMPTY,
                enqueueSnackbar,
                'error',
            );
            return () => {
                x.dispose();
            }
        }

        const keys = Object.keys(x.data[0]);

        keys.map((key) => {
            if (key === 'category') {
                return;
            }
            createSeries(key, `${key}`);
        });

        // createSeries('first', 'The First');
        // createSeries('second', 'The Second');
        // createSeries('third', 'The Third');

        function arrangeColumns() {
            var series = x.series.getIndex(0);

            var w =
                1 -
                xAxis.renderer.cellStartLocation -
                (1 - xAxis.renderer.cellEndLocation);
            if (series.dataItems.length > 1) {
                var x0 = xAxis.getX(series.dataItems.getIndex(0), 'categoryX');
                var x1 = xAxis.getX(series.dataItems.getIndex(1), 'categoryX');
                var delta = ((x1 - x0) / x.series.length) * w;
                if (am4core.isNumber(delta)) {
                    var middle = x.series.length / 2;

                    var newIndex = 0;
                    x.series.each(function (series) {
                        if (!series.isHidden && !series.isHiding) {
                            series.dummyData = newIndex;
                            newIndex++;
                        } else {
                            series.dummyData = x.series.indexOf(series);
                        }
                    });
                    var visibleCount = newIndex;
                    var newMiddle = visibleCount / 2;

                    x.series.each(function (series) {
                        var trueIndex = x.series.indexOf(series);
                        var newIndex = series.dummyData;

                        var dx =
                            (newIndex - trueIndex + middle - newMiddle) * delta;

                        series.animate(
                            { property: 'dx', to: dx },
                            series.interpolationDuration,
                            series.interpolationEasing,
                        );
                        series.bulletsContainer.animate(
                            { property: 'dx', to: dx },
                            series.interpolationDuration,
                            series.interpolationEasing,
                        );
                    });
                }
            }
        }

        chart.current = x;

        return () => {
            x.dispose();
        };
    }, [graphData]);

    return <div id="chartdiv" style={{ width: '100%', height: '500px' }}></div>;
}
export default EpgGraph;
